module.exports = __webpack_public_path__ + "img/back-top-token.9c9465b8.png";